import { nextTick, onBeforeUnmount, onMounted, ref, watch } from 'vue'
import { brand } from '@/config/brands'
import { superstoryTrack } from '@/track'

/** 一个可见元素的一次曝光；数据身份变化后重新计数。 */
export function useBrandExposure(name: string, params: () => Record<string, any>) {
  const target = ref<HTMLElement>()
  let observer: IntersectionObserver | undefined
  let exposed = false
  function connect() {
    observer?.disconnect()
    exposed = false
    if (brand !== 'superstory' || !target.value)
      return
    observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting && entry.intersectionRatio > 0.5 && !exposed) {
        exposed = true
        superstoryTrack(name, params())
      }
    }, { threshold: [0, 0.51] })
    observer.observe(target.value)
  }
  onMounted(connect)
  watch(() => JSON.stringify(params()), connect)
  onBeforeUnmount(() => observer?.disconnect())
  return target
}
export function useBrandListExposure<T>(items: () => T[], params: (item: T, index: number) => Record<string, any>, name = 'recharge_package_exp') {
  const target = ref<HTMLElement>()
  let observer: IntersectionObserver | undefined
  const seen = new Set<string>()
  function connect() {
    observer?.disconnect()
    if (brand !== 'superstory' || !target.value)
      return
    observer = new IntersectionObserver(entries => entries.forEach((entry) => {
      if (!entry.isIntersecting || entry.intersectionRatio <= 0.5)
        return
      const index = Number((entry.target as HTMLElement).dataset.exposureIndex)
      const item = items()[index]
      if (!item)
        return
      const values = params(item, index)
      const key = JSON.stringify(values)
      if (seen.has(key))
        return
      seen.add(key)
      superstoryTrack(name, values)
    }), { threshold: [0, 0.51] })
    target.value.querySelectorAll('[data-exposure-index]').forEach(el => observer!.observe(el))
  }
  onMounted(connect)
  watch(items, () => {
    nextTick(connect)
  }, { deep: true })
  onBeforeUnmount(() => observer?.disconnect())
  return target
}
